import { inject } from '@angular/core';
import { SupportUserService } from '@shared/services/support-user.service';

export const supportUserGuard = (): boolean => {
  const supportUserService = inject(SupportUserService);

  return !!supportUserService.isSupportUser();
};
